import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { getProsecutorDetailByEmployeeId } from "app/apis/users";
import { useTranslation } from "react-i18next";

const EmployeeProfile = ({ request }) => {
  const { t } = useTranslation();
  const [userDetail, setUserDetail] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!request) return;

    const fetchEmployeeDetail = async () => {
      try {
        const response = await getProsecutorDetailByEmployeeId(request);
        setUserDetail(response?.data);
      } catch (error) {
        setError(error.message || t('Failed to fetch employee details'));
        console.error('Error fetching employee details:', error);
      }
    };

    fetchEmployeeDetail();
  }, [request]);

  return (
    <div className="flex items-center space-x-4 p-2 w-full bg-opacity-75">
      {userDetail && (
        <div className="relative w-12 h-12 flex items-center justify-center rounded-full border border-black">
          <FontAwesomeIcon icon={faUser} className="text-black w-6 h-6" />
        </div>
      )}
      <div>
        <h2
          className="text-[18] font-semibold"
          style={{ color: "#432101AB", fontFamily: "Pretendard", fontWeight: "600", fontSize: "18px" }}
        >
          {[
            userDetail?.first_name,
            userDetail?.last_name
          ].filter(Boolean).join(' ')}
        </h2>

      </div>
    </div>
  );
};

export default EmployeeProfile;